var generateStyle = function generateStyle(componentTheme) {
  return {
    itemWrapper: {
      position: 'relative'
    },
    needsGradingDot: {
      width: componentTheme.dotSize,
      height: componentTheme.dotSize,
      background: componentTheme.dotBackgroundColor,
      borderRadius: '50%',
      position: 'absolute',
      top: '50%',
      left: "calc(".concat(componentTheme.dotSize, " / -2)"),
      marginTop: '-0.3rem'
    }
  };
};
export default generateStyle;